import { connect } from "react-redux";
import dayjs from "dayjs";
import { ProgressBar } from "primereact/progressbar";
import { useIntl } from "react-intl";
import { learningProgramsRequest } from "../../../store/slices/selfSlice";
import Section from "../../common/section";
import List from "../../common/list";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../../../constants";
import { useMountEffect } from "primereact/hooks";
import { getProgramStatus } from "../../../helpers/LearningStatus";
import OptionalTag from "../../common/OptionalTag";

export const LearningProgramWidget = ({
  learningPrograms,
  learningProgramsRequest,
  style = {},
  filters = { status: [] },
  linkHeader = false,
  headerLinkUrl = RouteConstants.APP_ROUTE_LEARNING_JOURNEY_PROGRAMS,
  getStatusProps = () => {},
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  useMountEffect(() => {
    learningProgramsRequest();
  });

  return (
    <Section
      title="my_learnings"
      link={(linkHeader && headerLinkUrl) || ""}
      className="edelxms-widget"
      style={style}
    >
      <List
        style={{ height: "100%" }}
        selectionMode=""
        pagination={false}
        handleRowClick={(data) =>
          navigate(
            `${RouteConstants.APP_ROUTE_LEARNING_JOURNEY_PROGRAMS_MILESTONES.replace(
              ":id",
              data.data.id
            )}`
          )
        }
        data={
          learningPrograms.filter((program) => {
            const { status = "" } = getStatusProps(program) || {};
            return (
              filters.status.includes(status) || filters.status.length === 0
            );
          }) || []
        }
        columns={[
          {
            field: "learningPathway.name",
            header: "name",
            body: (data) => (
              <div className="flex align-items-center gap-2">
                <span>{data?.learningPathway?.name}</span>
                {(data?.isOptional && <OptionalTag />) || null}
              </div>
            ),
          },
          {
            field: "completionPercentage",
            header: "progress",
            body: (data) => {
              const completionPercentage =
                data.completionCount.completedCount /
                data.completionCount.totalCount;
              return (
                <div className="flex align-items-center">
                  <div className="w-full">
                    <ProgressBar
                      showValue={false}
                      style={{ height: "0.75rem" }}
                      color="#c996fa"
                      value={completionPercentage * 100}
                    ></ProgressBar>
                  </div>
                  <div className="ml-2">
                    {Math.ceil(completionPercentage * 100)}%
                  </div>
                </div>
              );
            },
          },
          {
            field: "endDate",
            header: "due_date",
            body: (data) => {
              if (!data.endDate || data.isOptional) {
                return "N/A";
              }

              const { status } = getProgramStatus(data);
              const endDate = dayjs
                .utc(data.endDate)
                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

              return (
                <div className={status === "overdue" ? "text-red-500" : ""}>
                  {endDate.format("DD MMM, YYYY")}
                </div>
              );
            },
          },
          {
            field: "status",
            header: "status",
            body: (data) => {
              const { status, color } = getProgramStatus(data);

              return (
                <div
                  style={{
                    backgroundColor: color,
                    color: "white",
                    width: "100px",
                    textAlign: "center",
                    borderRadius: "5px",
                    padding: "2px",
                  }}
                  className="text-sm"
                >
                  {intl.formatMessage({ id: status }).toUpperCase()}
                </div>
              );
            },
          },
        ]}
      />
    </Section>
  );
};

const mapStateToProps = (state) => ({
  learningPrograms: state.self?.learningPrograms || [],
});

const mapDispatchToProps = (dispatch) => ({
  learningProgramsRequest: () => dispatch(learningProgramsRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningProgramWidget);
